/**
 * 三包登记的新增页面 货品配置处理
 * @author zjs
 * @time 2017-09-18
 */
let vm = {
    isTriggerFunc: true, // 标识是否触发func配置的调用
    data () {
        return {
            productConfig: [{
                prop: 'customer',
                label: '客户编码',
                width: 120,
                json: {
                    width: '471px',
                    api: 'api/customer',
                    prop: 'customer_account',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 200
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'customer',
                label: '客户名称',
                width: 200,
                json: {
                    width: '500px',
                    api: 'api/customer',
                    prop: 'customer_name',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 200
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'huikuan_amount',
                label: '实收/实退金额',
                width: 100,
                component: 'LyInputNumber'
            }, {
                prop: 'shouxufei',
                label: '手续费(非必填)',
                width: 100,
                component: 'LyInputNumber'
            }, {
                prop: 'weidu_id',
                label: '核算纬度',
                width: 100,
                component: 'LySelect',
                json: {
                    defOne: true,
                    all: false,
                    api: "api/accountingDimension"
                }
            }, {
                prop: 'wlye',
                label: '往来余额',
                width:   80,
                json: {
                    api: 'api/wanglaiz',
                    showkey: 'amount',
                    watch:'customer',
                    watch2: 'weidu_id'
                },
                component: 'LyAutoText'
            }, {
                prop: 'employee_id',
                label: '单据业务员',
                width: 150,
                component: 'LySelect',
                json: {
                    defOne: false,
                    all: false,
                    api: "api/employee"
                }
            }, {
                prop: 'remark',
                label: '备注',
                component: 'ElInput'
            },
            {
                type: 'function',
                func (list, next) {
                     // 如果是修改，初始的数据不用进行计算
                    if (!vm.isTriggerFunc) {
                        vm.isTriggerFunc = true
                        // 修改时 next 必须要有 by welpher 2022-1-17
                        next()
                        return
                    }
                    vm.timer && clearTimeout(vm.timer)
                    // 延迟执行
                    vm.timer = setTimeout(() => {
                        // 遍历货品数据
                        list.forEach((v, k) => {
                            // 填充业务员
                            if (v.customer && v.customer.employee_id) {
                                v.employee_id = v.customer.employee_id
                                delete v.customer.employee_id
                            }
                            // v.weidu_id = String(v.brand.value)
                        })
                        // 暂存当前列表
                        // vm.productList = utils.deepClone(list)
                        next()
                    }, 100)
                }
            }
        ]
        }
    }
}
export default vm